/**
* @Author: zachalam
* @Date:   2017-02-15T14:08:27-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-15T14:08:28-08:00
*/

let initialState = {
  errors: '',
  isFetching: false,
  modalOpen: false
};

const common = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_ERRORS':
      // store a general purpose error
      return {
        ...state,
        errors: action.payload
      }
    case 'STORE_SPECIFIC_ERRORS':
      // store a unique error.
      let errors = {};
      errors[action.name] = action.payload;
      return {
        ...state,
        errors
      }
    case 'CLEAR_ERRORS':
      return {
        ...state,
        errors: ''
      }
    case 'IS_FETCHING':
      return {
        ...state,
        isFetching: !state.isFetching
      }
    default:
      return state;
  }
}

export default common;



// WEBPACK FOOTER //
// ./src/reducers/common.js